
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-74a7c77a&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ViewPicks.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./ViewPicks.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-74a7c77a!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./ViewPicks.vue"),
  /* scopeId */
  "data-v-74a7c77a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/ViewPicks.vue
// module id = 462
// module chunks = 1